import { useEffect, useState } from 'react';
import { StepLayout } from '../components/StepLayout';
import { UI } from '../lib/ui';
import { useAction, usePortal } from '../Portal';


export function OtpVerify() {
  const { config, t, api, state, dispatch } = usePortal();
  const [code, setCode] = useState('');
  const [cooldown, setCooldown] = useState(config.otpResendSeconds);
  const [info, setInfo] = useState<string | null>(null);
  const verify = useAction();
  const resend = useAction();

  useEffect(() => {
    if (cooldown <= 0) return;
    const timer = window.setTimeout(() => setCooldown((seconds) => seconds - 1), 1000);
    return () => window.clearTimeout(timer);
  }, [cooldown]);

  const challenge = state.challenge;
  if (!challenge) return null;

  const submit = () =>
    verify.run(async () => {
      const result = await api.verifyOtp({ challenge, otp: code });
      api.setSession(result.session);
      dispatch({ type: 'ORDER_LOADED', view: result.view });
    });

  const resendCode = () =>
    resend.run(async () => {
      setInfo(null);
      await api.resendOtp({ challenge });
      setInfo(UI.otpResent);
      setCooldown(config.otpResendSeconds);
    });

  return (
    <StepLayout
      title={t('otp.title')}
      paragraph={state.otpDelivered ? t('otp.body', { email: state.email }) : UI.otpPending(state.email)}
      error={verify.error ?? resend.error}
      busy={verify.busy}
      onBack={() => dispatch({ type: 'BACK' })}
      onNext={submit}
      nextLabel={t('otp.submit')}
      nextDisabled={!/^\d{4,10}$/.test(code)}
    >
      <label className="nvd-claim-portal__field">
        <span className="nvd-claim-portal__label">{t('otp.codeLabel')}</span>
        <input
          className="nvd-claim-portal__input nvd-claim-portal__input--code"
          inputMode="numeric"
          autoComplete="one-time-code"
          maxLength={10}
          value={code}
          onChange={(event) => setCode(event.target.value.replace(/\D/g, ''))}
        />
      </label>
      <button type="button" className="nvd-claim-portal__link" onClick={resendCode} disabled={cooldown > 0 || resend.busy}>
        {cooldown > 0 ? t('otp.resendIn', { seconds: cooldown }) : t('otp.resend')}
      </button>
      <p className="nvd-claim-portal__note">{info ?? t('otp.spamHint')}</p>
    </StepLayout>
  );
}
